// =============================================================================
// NAD+ Shop Cards V2 Section Component
// =============================================================================

import Swiper from 'swiper';

export class NADShopCardsV2 {
  private element: HTMLElement;
  private observer: IntersectionObserver | null = null;
  private swiper: Swiper | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.initSwiper();
    this.setupScrollAnimation();
  }

  private initSwiper(): void {
    const swiperElement = this.element.querySelector<HTMLElement>('.nad-shop-cards-v2__track');
    if (!swiperElement) return;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      grabCursor: true,
      centerInsufficientSlides: true,
      breakpoints: {
        // The edge offsets skew centerInsufficientSlides' math; drop them on
        // desktop where the row fits and gets centered (Figma 2553:2505).
        // 1024 = the SCSS respond-above(md) breakpoint
        1024: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    });
  }

  /**
   * Fade in each card as it becomes visible; stagger delays come from the
   * nth-child rules in the section SCSS
   */
  private setupScrollAnimation(): void {
    const items = this.element.querySelectorAll<HTMLElement>('.nad-shop-cards-v2__item');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            this.observer?.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    items.forEach((item) => this.observer?.observe(item));
  }

  public destroy(): void {
    this.swiper?.destroy(true, true);
    this.swiper = null;
    this.observer?.disconnect();
    this.observer = null;
    this.element.querySelectorAll('.nad-shop-cards-v2__item.animate-in')
      .forEach(el => el.classList.remove('animate-in'));
  }

  static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-shop-cards-v2')
      .forEach(el => {
        if (!(el as any)._nadComponentInstance) {
          (el as any)._nadComponentInstance = new NADShopCardsV2(el);
        }
      });
  }
}
